import React from 'react';
import { motion } from 'framer-motion';
export const ProblemAndWhatIs = () => {
  return <section className="py-12 md:py-20 px-4 bg-forest-900/40" data-id="element-63">
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-50px'
    }} transition={{
      duration: 0.4
    }} className="max-w-2xl mx-auto text-center" data-id="element-64">
        <div className="space-y-3 md:space-y-4 font-anton text-2xl md:text-4xl uppercase tracking-wide text-white leading-tight" data-id="element-65">
          <p data-id="element-66">No es falta de ganas.</p>
          <p data-id="element-67">No es falta de disciplina.</p>
          <p data-id="element-68">No es falta de talento.</p>
          <p className="pt-2 md:pt-3 text-grass-400" data-id="element-69">
            Es falta de{' '}
            <span className="underline decoration-grass-400 decoration-4 underline-offset-[6px]" data-id="element-70">
              sistema
            </span>
            .
          </p>
        </div>
      </motion.div>
    </section>;
};